import Workspace from 'iam/models/Workspace'
import { action, computed, makeObservable, observable } from 'mobx'

export default class FirmDashboardContractViewModel {
  constructor() {
    makeObservable(this)
  }

  @observable
  currentWorkspace = Workspace.none

  /**
   * Whether the contract config is enabled within the workspace.
   */
  @computed
  get isContractConfigEnabled() {
    return Boolean(this.currentWorkspace.config.contract_config?.enabled)
  }

  /**
   * Total amount ($USD) of the contract.
   */
  @computed
  get contractTotal() {
    return this.currentWorkspace.config.contract_config?.amount || 0
  }

  @computed
  get feeAmount() {
    return this.vmFees + this.setupFees
  }

  @computed
  get vmFees() {
    return this.vmFeesAmountPerUnit * this.vmFeesQuantity
  }

  @computed
  get vmFeesQuantity() {
    const vmFees = this.currentWorkspace.config.contract_config?.vm_fees
    return vmFees?.quantity || 0
  }

  @computed
  get vmFeesAmountPerUnit() {
    const vmFees = this.currentWorkspace.config.contract_config?.vm_fees
    return vmFees?.amount_per_unit || 0
  }

  get setupFees() {
    const setupFees = this.currentWorkspace.config.contract_config?.setup_fees
    return setupFees?.amount || 0
  }

  /**
   * Start date of the contract.
   */
  @computed
  get contractStartDate() {
    return this.isContractConfigEnabled
      ? new Date(this.currentWorkspace.config.contract_config!.start_date)
      : null
  }

  /**
   * End date of the contract.
   */
  @computed
  get contractEndDate() {
    return this.isContractConfigEnabled
      ? new Date(this.currentWorkspace.config.contract_config!.end_date)
      : null
  }

  @action.bound
  setCurrentWorkspace(workspace: Workspace) {
    this.currentWorkspace = workspace
  }
}
